export interface ITranslations {
  hotpointCursor: string
  hotpointCursonNoSpace: string
  moveCursor: string
  discover: string
  discoverFeatures: string
  open: string
  close: string
  side: string
  front: string
  dimensions: string
  summary: string
  comparison: string
  recommendedTogether?: string
  reccommendedTogether: string
  check: string
  comparisonSwipe: string
  faq: string
  accessories: string
  accessoriesIncluded: string
  atYourHome: string
  packageContents: string
  technicalDrawing: string
  moveToUnfoldDescription: string
  AIGenerated: string
  AIModified: string
}

export interface ITranslationsQueryPayload {
  brandId: string
  country: string
}

export const TRANSLATION_STATUS = {
  pending: 'pending',
  validating: 'validating',
  translating: 'translating',
  copying_files: 'copying_files',
  creating_product: 'creating_product',
  translating_assets: 'translating_assets',
  finalizing: 'finalizing',
  completed: 'completed',
  failed: 'failed'
} as const

export type TranslationStatus =
  (typeof TRANSLATION_STATUS)[keyof typeof TRANSLATION_STATUS]

export interface TranslationProgress {
  id: string
  productId: string
  sourceCountry: string
  targetCountry: string
  status: TranslationStatus
  progress: number
  message: string
  startTime: string
  endTime?: string
  error?: string
  translatedAssetCount?: number
  totalAssets?: number
  estimatedTimeRemaining?: number
  translatedProductId?: string
  fromCache?: boolean
  originalTranslationId?: string
}
